/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleDrawerHeaderVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  label: number | null
  fccHandledBy: Array<{
    __typename?: 'FccVehicleHandledBy'
    role: Types.FccOperatorRoleType
    backofficeUserId: string
    backofficeUser: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
  }>
  fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
  fccHandledByOperatorDetails: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  pooling: { __typename?: 'Pooling'; enabled: boolean } | null
}

export const AdVehicleDrawerHeaderVehicleFragmentDoc = gql`
    fragment AdVehicleDrawerHeaderVehicle on Vehicle {
  id
  inService
  label
  ...HandlingOperatorVehicle
  ...AdPoolingToggleVehicle
}
    `
